import React, { useEffect, useRef, useState } from 'react';
import './editAnswer.style.scss';
import { useHistory, useParams } from 'react-router-dom';
import { FormShowType, ReduxState, Answer, Question, AnswerItem, AnswerStatus, FormDetail } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { post } from 'scripts/api';
import { Spinner } from 'react-bootstrap';
import SLPLayout, { SLPLayoutRef } from '../../../SLP/SLPLayout/SLPLayout.index';
// import SLPFooter from '../../SLP/footer/footer.index';
import SLPWizard from '../../../SLP/wizard/wizard.index';
import { API } from 'data';
import { __EditAnswerProps } from './editAnswer.interface';
import { getDBAnswer, setPublishAnswers } from 'scripts/db';
import { setInitialAnswerList, SLPLogicalRelationship } from 'ucheck/SLP/SLP.script';

const EditAnswer: React.FC<__EditAnswerProps & ConnectedProps<typeof connector>> = function (
    props: __EditAnswerProps & ConnectedProps<typeof connector>,
) {
    const { publish, form, answer } = useParams<any>();
    const [step, setStep] = useState<number>(0);
    const answerDetail = useRef<Answer>();
    const [formDetail, setFormDetail] = useState<FormDetail>();
    const viewBox = useRef<HTMLDivElement>(null);
    const [wizardIndex, setWizardIndex] = useState<number>(0);
    const qRefs = useRef<SLPLayoutRef[]>([]);
    const [answerList, setAnswerList] = useState<AnswerItem[]>();
    const history = useHistory();
    const questionBox = useRef<HTMLDivElement[]>([]);
    const [questions, setQuestion] = useState<Question[][]>([[]]);
    let currentQuestion: Question | undefined = undefined;
    if (formDetail?.show_type === FormShowType.single && questions[step] && questions[step][wizardIndex]) {
        currentQuestion = questions[step][wizardIndex];
    } else if (step !== undefined && questions[step].length && questions[step][questions[step].length - 1]) {
        currentQuestion = questions[step][questions[step].length - 1];
    }

    useEffect(() => {
        onInit();
        return () => {
            if (answerDetail.current)
                setPublishAnswers([answerDetail.current], answerDetail.current.questionerOffline ? 1 : 0);
        };
    }, []);

    function onInit() {
        setWizardIndex(0);
        setStep(0);
        getDBAnswer(Number(answer)).then((res) => {
            if (!res) return;
            answerDetail.current = res;
            setAnswerList(
                setInitialAnswerList(
                    answerDetail.current ? [...answerDetail.current.items] : [],
                    currentQuestion?.id,
                    res.form,
                ),
            );
            setFormDetail(res.form);
        });
    }

    function onEnd() {
        return new Promise((resolve) => {
            if (!answerDetail.current) {
                resolve(true);
                return;
            }
            answerDetail.current.end_date = new Date().toISOString();
            answerDetail.current.state = AnswerStatus.complete;
            setPublishAnswers([answer.current], answer.current.questionerOffline ? 1 : 0);
            history.goBack();
            // console.log(publishAnswer.current, publishData.get());
        });
    }

    useEffect(() => {
        if (props.goback) {
            props.setGoback();
            history.goBack();
        }
    }, [props.goback]);

    function onNext() {
        if (!formDetail) return;
        if (formDetail.show_type === FormShowType.single) {
            if (qRefs.current[wizardIndex]?.validate(true)) {
                if (formDetail?.show_type === FormShowType.single) qRefs.current[wizardIndex]?.submit(false);
                if (wizardIndex < questions[step].length - 1) setWizardIndex(wizardIndex + 1);
                else onEnd();
            }
        } else if (formDetail.show_type === FormShowType.multiple) {
            let errorIndex: number | undefined = undefined;
            qRefs.current.forEach((question, index) => {
                if (!question.validate(true) && errorIndex === undefined) errorIndex = index;
            });
            if (errorIndex !== undefined) {
                questionBox.current[errorIndex].scrollIntoView();
            } else {
                qRefs.current.forEach((question, index) => {
                    question.submit(true);
                });
                if (step < questions.length - 1) {
                    setStep(step + 1);
                    setWizardIndex(0);
                } else history.goBack();
            }
        }
    }

    function onPrev(page?: boolean) {
        if (!formDetail) return;
        if (page && step > 0) {
            // go to previous page
            setStep(step - 1);
            setWizardIndex(0);
        } else if (wizardIndex > 0 && formDetail.show_type === FormShowType.single) {
            // go to previous question
            setWizardIndex(wizardIndex - 1);
        } else if (wizardIndex === 0 && step > 0) {
            // go to previous page
            setStep(step - 1);
            setWizardIndex(0);
        }
    }

    useEffect(() => {
        let ques: Question[][] = [];
        if (formDetail?.show_type === FormShowType.single) {
            const temp = SLPLogicalRelationship(
                formDetail,
                answerList ? answerList : [],
                currentQuestion?.id,
                answer?.answerer_info,
            );
            ques = [[]];
            for (const list of temp) {
                ques = [[...ques[0], ...list.sort((a, b) => a.order - b.order)]];
            }
        } else if (formDetail) {
            const temp = SLPLogicalRelationship(
                formDetail,
                answerList ? answerList : [],
                currentQuestion?.id,
                answer?.answerer_info,
            );
            ques = [];
            for (const list of temp) {
                if (list.length) ques.push([...list.sort((a, b) => a.order - b.order)]);
            }
        }
        if (
            ques.map((i) => i.map((j) => j.id).join('')).join('') !==
            questions.map((i) => i.map((j) => j.id).join('')).join('')
        ) {
            setQuestion(ques);
        }
    }, [formDetail, answerList, answer, currentQuestion?.id, step, questions]);

    function onSlideChange(e: number) {
        if (formDetail?.show_type === FormShowType.multiple) qRefs.current[wizardIndex]?.submit(false);
        setWizardIndex(e);
    }

    function submitAnswerItem(item: AnswerItem) {
        const answerItem: AnswerItem = {
            value: item.value,
            question_items: item.question_items,
            question: item.question,
            created_at: new Date().toISOString(),
            id: item.id,
        };
        const objApi: any = {
            value: item.value,
            answer: answer,
            question: item.question.id,
        };
        if (!item.value) objApi.question_items = item.question_items?.map((i) => i.id);
        if (answerDetail.current?.access_token)
            post<AnswerItem>(API.answers.answerItem(answerDetail.current?.access_token), objApi)
                .then((res) => (answerItem.id = res.data.id))
                .catch(() => (answerItem.questionerOffline = true))
                .finally(() => {
                    if (!answerDetail || !answerDetail?.current) return;
                    const indexItem = answerDetail.current.items.findIndex((i) => i.question.id === item.question.id);
                    if (indexItem === undefined || indexItem < 0) answerDetail.current.items.push(answerItem);
                    else answerDetail.current.items[indexItem] = answerItem;
                });
    }
    // console.log(answerList);
    return (
        <div className={`ucheck-edit-answer-higher-order`}>
            <div
                style={{
                    background: formDetail?.background_image_file
                        ? 'url(' + formDetail?.background_image_file?.file + ')'
                        : formDetail?.background_color
                        ? formDetail.background_color
                        : undefined,
                }}
                className="slp-view-box"
                ref={viewBox}
            >
                {formDetail &&
                    answerList &&
                    questions.map((section, sectionIndex) => {
                        if (step !== sectionIndex) return null;
                        let reInit = false;
                        if (qRefs.current.length !== section.length) {
                            qRefs.current = [];
                            reInit = true;
                        }
                        qRefs.current = [];
                        questionBox.current = [];
                        return (
                            <SLPWizard
                                className="slp-body"
                                key={sectionIndex}
                                questions={section}
                                wizardIndex={wizardIndex}
                                sectionIndex={sectionIndex}
                                form={formDetail}
                                onChange={onSlideChange}
                                layout={(quiz, index) => (
                                    <div
                                        ref={(ref) => {
                                            if (ref) questionBox.current.push(ref);
                                        }}
                                        key={quiz.id}
                                    >
                                        <SLPLayout
                                            ref={(ref) => {
                                                if (ref && reInit) qRefs.current.push(ref);
                                                else if (ref) qRefs.current[index] = ref;
                                            }}
                                            key={index}
                                            form={formDetail}
                                            questions={questions}
                                            sectionIndex={sectionIndex}
                                            questionIndex={index}
                                            next={onNext}
                                            previous={onPrev}
                                            answerList={answerList}
                                            setAnswerList={(answersList) =>
                                                setAnswerList(
                                                    setInitialAnswerList(answersList, currentQuestion?.id, formDetail),
                                                )
                                            }
                                            answer={answerDetail.current}
                                            submit={submitAnswerItem}
                                            cancel={history.goBack}
                                        />
                                    </div>
                                )}
                            />
                        );
                    })}
                {!formDetail ||
                    (!answerDetail && !answerList && (
                        <div className="loading-content">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ))}
            </div>
            {/* <SLPFooter
                form={formDetail}
                question={step !== 'start' && step !== 'end' ? questions[step][wizardIndex] : undefined}
                onNext={onNext}
                onPrev={onPrev}
                cover={props.footerCover}
            /> */}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
});

const connector = connect(mapStateToProps);
export default connector(EditAnswer);
